import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import '@etchteam/diamond-ui/composition/Enter/Enter';
import '@etchteam/diamond-ui/canvas/Section/Section';
import '@/components/composition/Wrap/Wrap';
import '@/components/composition/BorderedList/BorderedList';
import Footer from '@/components/content/Footer/Footer';
import '@/components/control/IconLink/IconLink';
import formatPostcode from '@/lib/formatPostcode';
import { usePostcodeLoaderData } from '@/pages/[postcode]/postcode.loader';
export default function Menu({ handleClose, }) {
    const { postcode, city } = usePostcodeLoaderData();
    const { t } = useTranslation();
    const location = useLocation();
    const items = [
        {
            icon: 'pin',
            text: t('components.menu.changeLocation'),
            to: '/?autofocus=true',
        },
        {
            icon: 'search',
            text: t('components.menu.recycleSpecificItem'),
            to: `/${encodeURIComponent(postcode)}?autofocus=true`,
        },
        {
            icon: 'home',
            text: t('components.menu.homeRecycling'),
            to: `/${encodeURIComponent(postcode)}/home`,
        },
        {
            icon: 'distance',
            text: t('components.menu.findNearbyPlaces'),
            to: `/${encodeURIComponent(postcode)}/places`,
        },
    ];
    const handleClick = (event, to) => {
        if (location.pathname === to.split('?')[0]) {
            // If the link is already active, close the menu
            event.preventDefault();
            handleClose();
        }
    };
    return (_jsxs("locator-menu", { children: [_jsx("diamond-enter", { type: "fade", children: _jsx("locator-context-header", { children: _jsxs("div", { children: [_jsx("span", { className: "diamond-text-weight-bold", children: formatPostcode(postcode) }), ' ', "\u2013 ", city] }) }) }), _jsx("diamond-section", { padding: "md", children: _jsxs("locator-wrap", { children: [_jsx("diamond-enter", { type: "fade", class: "diamond-spacing-bottom-md", children: _jsx("p", { className: "diamond-text-size-h4", children: t('components.menu.whatDoYouWantToDo') }) }), _jsx("nav", { children: _jsx("ul", { className: "locator-menu__menu-list", children: items.map((item, i) => (_jsx("li", { className: "diamond-spacing-bottom-md", children: _jsx("diamond-enter", { type: "fade", delay: i * 0.1, children: _jsx("locator-icon-link", { border: true, children: _jsxs(Link, { to: item.to, onClick: (event) => handleClick(event, item.to), children: [_jsx("locator-icon-circle", { children: _jsx("locator-icon", { icon: item.icon, color: "primary" }) }), item.text] }) }, item.icon) }) }, item.icon))) }) }), _jsxs("diamond-enter", { type: "fade", delay: items.length * 0.1, children: [_jsx("hr", { className: "diamond-spacing-bottom-md" }), _jsx(Footer, {})] })] }) })] }));
}
